export const reverseData = data => {
  if (!data) {
    return []
  }
  const dataReverse = []
  data.map(newsletter => {
    newsletter.months.map(month => {
      month.newsletters.reverse()
    })
    newsletter.months.reverse()
    dataReverse.push(newsletter)
  })
  return dataReverse
}
